import React from 'react';
import img1 from '../../../Clients/+.png';
import img2 from '../../../Clients/1-1-200x100-1.png';
import img3 from '../../../Clients/2-200x100-1.png';
import img4 from '../../../Clients/3-200x100-1.png';
import img5 from '../../../Clients/Chilis.png';
import img6 from '../../../Clients/Dekchi.png';
import img7 from '../../../Clients/Dentist.png';
import img8 from '../../../Clients/Doors-200x100-1.png';
import img9 from '../../../Clients/Eden.png';
import img10 from '../../../Clients/Fehi.png';
import img11 from '../../../Clients/galitos.png';
import img12 from '../../../Clients/Gelatisimo logo.png';
import img13 from '../../../Clients/Guardian Chambers.png';
import img14 from '../../../Clients/LOGO-DEkchi.png';
import img15 from '../../../Clients/Lakeshore_logo.png';
import img16 from '../../../Clients/Logo Gold.png';
import img17 from '../../../Clients/bowling.png';
import img18 from '../../../Clients/Peugeot-Brand-Logo-CMJN-WBG.png';
import img19 from '../../../Clients/Rabbithole.png';
import img20 from '../../../Clients/SC Progress.png';
import img21 from '../../../Clients/SLi.png';
import img22 from '../../../Clients/Santoor.png';
import img23 from '../../../Clients/Shawarma House.png';
import img24 from '../../../Clients/SwissContact.png';
import img25 from '../../../Clients/volvo.png';
import img26 from '../../../Clients/gazi.png';
import img27 from '../../../Clients/securitas.png';
import img28 from '../../../Clients/stand.png';
import img29 from '../../../Clients/Total Care white.png';
import './Client.css';

const Client = () => {
    return (
        <section className='bg-black py-8'>
            <h5 className='client-text'>Our Clients</h5>
            <div className='slider'>
                <div className='slide-track'>
                    <div className='slide'>
                        <img src={img1} alt="" />
                    </div>
                    <div className='slide'>
                        <img src={img2} alt="" />
                    </div>
                    <div className='slide'>
                        <img src={img3} alt="" />
                    </div>
                    <div className='slide'>
                        <img src={img4} alt="" />
                    </div>
                    <div className='slide'>
                        <img src={img5} alt="" />
                    </div>
                    <div className='slide'>
                        <img src={img6} alt="" />
                    </div>
                    <div className='slide'>
                        <img src={img7} alt="" />
                    </div>
                    <div className='slide'>
                        <img src={img8} alt="" />
                    </div>
                    <div className='slide'>
                        <img src={img9} alt="" />
                    </div>
                    <div className='slide'>
                        <img src={img10} alt="" />
                    </div>
                    <div className='slide'>
                        <img src={img11} alt="" />
                    </div>
                    <div className='slide'>
                        <img src={img12} alt="" />
                    </div>
                    <div className='slide'>
                        <img src={img13} alt="" />
                    </div>
                    <div className='slide'>
                        <img src={img14} alt="" />
                    </div>
                    <div className='slide'>
                        <img src={img15} alt="" />
                    </div>
                    <div className='slide'>
                        <img src={img16} alt="" />
                    </div>
                    <div className='slide'>
                        <img src={img17} alt="" />
                    </div>
                    <div className='slide'>
                        <img src={img18} alt="" />
                    </div>
                    <div className='slide'>
                        <img src={img19} alt="" className='img-change ' />
                    </div>
                    <div className='slide'>
                        <img src={img20} alt="" className='img-change' />
                    </div>
                    <div className='slide'>
                        <img src={img21} alt="" className='img-change' />
                    </div>
                    <div className='slide'>
                        <img src={img22} alt="" />
                    </div>
                    <div className='slide'>
                        <img src={img23} alt="" />
                    </div>
                    <div className='slide'>
                        <img src={img24} alt="" />
                    </div>
                    <div className='slide'>
                        <img src={img25} alt="" />
                    </div>
                    <div className='slide'>
                        <img src={img26} alt="" />
                    </div>
                    <div className='slide'>
                        <img src={img27} alt="" />
                    </div>
                    <div className='slide'>
                        <img src={img28} alt="" />
                    </div>
                    <div className='slide'>
                        <img src={img29} alt="" />
                    </div>
                </div>
            </div >
        </section>
    );
};

export default Client;